import { render } from "./CreateFormModal.vue?vue&type=template&id=58f1d71a&scoped=true&ts=true"
import script from "./CreateFormModal.vue?vue&type=script&lang=ts"
export * from "./CreateFormModal.vue?vue&type=script&lang=ts"

import "./CreateFormModal.vue?vue&type=style&index=0&id=58f1d71a&lang=scss&scoped=true"
import "./CreateFormModal.vue?vue&type=style&index=1&id=58f1d71a&scoped=true&lang=css"

import exportComponent from "C:\\Users\\DELL\\Documents\\vyzor\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-58f1d71a"]])

export default __exports__